export default __webpack_public_path__ + "arrow_drop_down.3820fdd4.svg";